/**
 * 文件类型
 *
 * @author LCTR
 * @date 2022-09-21
 */
export enum FileType {
    电子文档 = '电子文档',
    电子表格 = '电子表格',
    文本文件 = '文本文件',
    图片 = '图片',
    音频 = '音频',
    视频 = '视频',
    压缩包 = '压缩包',
    未知 = '未知',
    外链资源 = '外链资源'
}